import { render, staticRenderFns } from "./SpecialOfferFilter.vue?vue&type=template&id=24885e84"
import script from "./SpecialOfferFilter.vue?vue&type=script&lang=js"
export * from "./SpecialOfferFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports